
export default {
  orsDictionary: {
    'unknown': 'Ismeretlen',
    'paved': 'Burkolt',
    'unpaved': 'Burkolatlan',
    'asphalt': 'Aszfalt',
    'concrete': 'Beton',
    'cobblestone': 'Nagy kavics',
    'metal': 'Fém',
    'wood': 'Fa',
    'compactedGravel': 'Tömörített zúzott kő',
    'fineGravel': 'Murva',
    'gravel': 'Zúzott kő',
    'dirt': 'Por',
    'ground': 'Föld',
    'ice': 'Jég',
    'pavingStones': 'Térkő',
    'sand': 'Homok',
    'woodchips': 'Faapríték',
    'grass': 'Fű',
    'grassPaver': 'Gyephézagos térkő',
    'none': 'Nincs',
    'no': 'Tilos',
    'customers': 'Ügyfeleknek',
    'destination': 'Célforgalom',
    'delivery': 'Áruszállítás',
    'private': 'Engedéllyel',
    'permissive': 'Megtűrt',
    'stateRoad': 'Főút',
    'road': 'Egyéb út',
    'street': 'Utca',
    'path': 'Ösvény',
    'track': 'Mezőgazdasági út',
    'cycleway': 'Kerékpárút',
    'footway': 'Gyalogút',
    'steps': 'Lépcső',
    'ferry': 'Komp',
    'construction': 'Építkezés',
    'concrete:lanes': 'beton nyomsávok',
    'paving_stones': 'térkő',
    'sett': 'Macskakő',
    'unhewn_cobblestone': 'Vágatlan nagy kavics',
    'compacted': 'Tömörített',
    'fine_gravel': 'Murva',
    'pebblestone': 'Kavics',
    'impassable': 'Járhatatlan',
    'very_horrible': 'Nagyon szörnyű',
    'horrible': 'Szörnyű',
    'very_bad': 'Nagyon rossz',
    'bad': 'Rossz',
    'intermediate': 'Közepes',
    'good': 'Jó',
    'excellent': 'Kitűnő',
    'grade1': '1 – tömör',
    'grade2': '2 – többnyire tömör',
    'grade3': '3 – vegyesen tömör és laza',
    'grade4': '4 – többnyire laza',
    'grade5': '5 – laza',
    'no_tollway': 'Nem fizetős',
    'is_tollway': 'Fizetős',
    'no_category': 'Besorolatlan',
    'highway': 'Autópálya',
    'unpaved_road': 'Burkolatlan út',
    'tunnel': 'Alagút',
    'paved_road': 'Burkolt út',
    'ford': 'Gázló',
    'no_data': 'Nincs adat'
  }
}
